import { creationsGetMy } from '@/app/services/vidu';
import type { CreationWithTask } from '@/app/types';
import type { GetMyCreationParams, GetMyCreationResult } from './types';

export const apiGetMyCreation = (query: GetMyCreationParams): Promise<GetMyCreationResult> => {
  return creationsGetMy({ query }).then(({ data, error, ...params }) => {
    if (!data || !data?.tasks || error) return { creations: [], error, params, total: 0 };
    const { creations, tasks, total } = data;
    const newCreation = creations.map(({ task_id, ...otherProps }) => {
      const task = tasks[task_id];
      return { ...otherProps, task, task_id } as CreationWithTask;
    });
    return { creations: newCreation, total };
  });
};
